import React from "react";

export default function AlurPeminjamanTextProduktif(){
    return(
        <div className='alur-peminjaman-text'>
            <div className='list'>
                <img src={require('../../../../assets/img/product/number-one.png')} alt='number1'/>
                <span>Ajukan pinjaman untuk kebutuhan usaha Anda melalui link <a
                    href={process.env.REACT_APP_LINK_COMPANY_WEB} className="text-white">Gabung Danai.id</a></span>
            </div>
            <div className='list'>
                <img src={require('../../../../assets/img/product/number-two.png')} alt='number2'/>
                <span>Tim Sales Marketing Danai.id akan menghubungi Anda melalui email, maupun nomor telepon yang terdaftar</span>
            </div>
            <div className='list'>
                <img src={require('../../../../assets/img/product/number-three.png')} alt='number3'/>
                <span>Siapkan persyaratan dokumen yang diperlukan</span>
            </div>
            <div className='list'>
                <img src={require('../../../../assets/img/product/number-four.png')} alt='number4'/>
                <span>Pengajuan pinjaman Anda akan diproses</span>
            </div>
            <div className='list'>
                <img src={require('../../../../assets/img/product/number-five.png')} alt='number5'/>
                <span>Cek secara berkala melalui email untuk mengetahui status pengajuan pinjaman Anda</span>
            </div>
            <div className='list'>
                <img src={require('../../../../assets/img/product/number-six.png')} alt='number6'/>
                <span>Jika pengajuan pinjaman Anda disetujui, dana akan dicairkan ke rekening yang Anda infokan sebelumnya melalui aplikasi pengajuan</span>
            </div>
        </div>
    );
}